import { lazy } from 'react';

const IndividualKRIModal = lazy(
  () => import('./components/IndividualKRIModal'),
);

const TabularViewSaveModal = lazy(
  () => import('./pages/KRITabularView/components/TabularViewSaveModal'),
);

const TabularViewLoadModal = lazy(
  () => import('./pages/KRITabularView/components/TabularViewLoadModal'),
);

export const TABULAR_VIEW_SAVE = 'TABULAR_VIEW_SAVE';
export const TABULAR_VIEW_LOAD = 'TABULAR_VIEW_LOAD';

export default {
  INDIVIDUAL_KRI_MODAL: IndividualKRIModal,
  [TABULAR_VIEW_SAVE]: TabularViewSaveModal,
  [TABULAR_VIEW_LOAD]: TabularViewLoadModal,
};
